import { render, staticRenderFns } from "./jxrz.vue?vue&type=template&id=5ba977f4&scoped=true"
import script from "./jxrz.vue?vue&type=script&lang=js"
export * from "./jxrz.vue?vue&type=script&lang=js"
import style0 from "./jxrz.vue?vue&type=style&index=0&id=5ba977f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba977f4",
  null
  
)

export default component.exports